import {combineReducers} from 'redux';
import {reducer as loginReducer, initialState as loginInitialState} from './login-reducer';
import {reducer as navegacionReducer, initialState as navegacionInitialState} from './navegacion-reducer';
import {reducer as principalReducer, initialState as principalInitialState} from './principal-reducer';
import {reducer as crearParcelaReducer, initialState as crearParcelaInitialState} from './crearParcela-reducer';
import {reducer as propiedadesReducer, initialState as propiedadesInitialState} from './propiedades-reducer';
import {reducer as gestionUsuariosReducer, initialState as gestionUsuariosInitialState} from './gestionUsuarios-reducer';
import {reducer as visualizadorReducer, initialState as visualizadorInitialState} from './visualizador-reducer';
import {reducer as riegonetoReducer, initialState as riegoNetoInitialState} from './riego_neto-reducer';
import {reducer as subirDatosReducer, initialState as subirDatosInitialState} from './subir_datos-reducer';
import {reducer as configReducer, initialState as configInitialState} from './config-reducer'
import {reducer as navegacionPartnersReducer, initialState as navegacionPartnersInitialState} from './navegacion-partners-reducer';
import {reducer as partnerReducer, initialState as partnerInitialState} from './partner-reducer';


export const combinedReducers = combineReducers({
  login: loginReducer,
  navegacion: navegacionReducer,
  principal: principalReducer,
  crearParcela: crearParcelaReducer,
  propiedades: propiedadesReducer,
  gestionUsuarios: gestionUsuariosReducer,
  visualizador: visualizadorReducer,
  riego: riegonetoReducer,
  subirDatos: subirDatosReducer,
  config: configReducer,
  navegacionPartners: navegacionPartnersReducer,
  partner: partnerReducer
});

export interface IStore {
  login: typeof loginInitialState
  navegacion: typeof navegacionInitialState
  principal: typeof principalInitialState
  crearParcela: typeof crearParcelaInitialState
  propiedades: typeof propiedadesInitialState
  gestionUsuarios: typeof gestionUsuariosInitialState
  visualizador: typeof visualizadorInitialState
  riego: typeof riegoNetoInitialState
  subirDatos: typeof subirDatosInitialState
  config: typeof configInitialState
  navegacionPartners: typeof navegacionPartnersInitialState
  partner: typeof partnerInitialState
}
